import { Component, OnInit, Input, Output, forwardRef, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormBuilder, Validators, FormGroup, AbstractControl, ValidationErrors, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-reactive-forms-text-input',
    templateUrl: './reactive-forms-text-input.component.html',
    styleUrls: ['./reactive-forms-text-input.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReactiveFormsTextInputComponent),
            multi: true
        }
    ]
})

export class ReactiveFormsTextInputComponent implements OnInit, ControlValueAccessor {
    @Input() property: string;
    @Input() model: any;
    @Input() myFormName: string;
    @Input() type = 'text';
    @Input() label: string;
    @Input() icon: string;
    @Input() info: string;
    @Input() pretext: string;
    @Input() append: string;
    @Input() size: string;
    @Input() length: number;
    @Input() numbersOnly: string;
    @Input() required: string;
    @Input() placeholder: string;
    @Input() readonly: boolean;
    @Output() modelChanged = new Subject<any>();
    @Output() changeComplete = new Subject<any>();

    value: string = '';

    @Input() id: string;

    constructor(
        private _renderer: Renderer2
    ) { }

    ngOnInit() {
        const self = this;
        this._inputElement.nativeElement.addEventListener('change', function (event) {
            self._onChange(this.value);
        });
        this._inputElement.nativeElement.addEventListener('keyup', function (event) {
            self._onChange(this.value);
        });
        this._inputElement.nativeElement.addEventListener('blur', function (event) {
            self._onTouched();
        });
    }

    changesComplete() {
        this.changeComplete.next({
          name: this.property,
          value: this.model
        })
      }
    
      changes(evt : any) {
        this.modelChanged.next({
          name: this.property,
          value: this.model
        })
      }


    @ViewChild('inputElement', { static: true }) private _inputElement: ElementRef;
    get inputElement(): ElementRef {
        return this._inputElement;
    }
    private _onChange = (_: any) => { };
    private _onTouched = () => { };

    writeValue(obj: any): void {
        this.value = obj;
    }
    registerOnChange(fn: any): void {
        this._onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this._renderer.setProperty(this._inputElement.nativeElement, 'disabled', isDisabled);
    }

    onChange(event: any) {
        this._onChange(event.target.value);
    }
    onKeyup(event: any) {
        this._onChange(event.target.value);
    }
    onBlur(event: any) {
        this._onTouched();
    }
}